import { t } from '@lingui/macro'
import { motion } from 'framer-motion'
import { useCallback } from 'react'

import { getDropInProps } from '@/modules/shared/animations/dropIn.animation'
import { ExternalSourceCard } from '@/modules/shared/components/source-card/external-source-card/ExternalSourceCard'
import { openUrl } from '@/utils/external-resources'
import { useMealLink } from '@/utils/navigation'

const SelectMealCard = ({ onClick }: { onClick?: () => void }) => {
  const mealLink = useMealLink()?.url

  const openMealLink = useCallback(() => {
    if (!mealLink) return
    openUrl(mealLink, { windowName: '_blank' })
  }, [mealLink])

  return (
    <motion.div {...getDropInProps()}>
      <ExternalSourceCard
        title={t({
          id: 'select-meal-card.title',
          message: 'Kies zelf je menu',
        })}
        description={t({
          id: 'select-meal-card.body',
          message: 'Via de knop hieronder kan je zelf je warme maaltijd samenstellen',
        })}
        icon={['fad', 'plate-utensils']}
        onClick={() => {
          onClick?.()
          openMealLink()
        }}
      />
    </motion.div>
  )
}

export { SelectMealCard }
